module.exports = __webpack_public_path__ + "static/49invgde-a40e02e036d71bbd778220d17f4b4e79.gif";